<template>
    <div class="favourites-container">
        <v-layout column wrap fill-height="true" v-if="userDetails.mangopayScaStatusId !== 2 || balanceSca">
            <div class="wallet-wrapper">
                <div class="not-verified-wrapper" v-if="balanceSca">
                    <div class="not-verified-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                            <circle cx="26.25" cy="55" r="10" fill="#B3CAD9"/>
                            <circle cx="56.25" cy="55" r="10" fill="#B3CAD9"/>
                            <path d="M22.1274 46.5651C23.2919 45.8218 24.6207 45.3131 26.047 45.1055L23.816 64.3001C22.4944 63.7762 21.3111 62.9786 20.3359 61.9774L22.1274 46.5651Z" fill="white"/>
                            <path d="M52.1274 46.5651C53.2919 45.8218 54.6207 45.3131 56.047 45.1055L53.816 64.3001C52.4944 63.7762 51.3111 62.9786 50.3359 61.9774L52.1274 46.5651Z" fill="white"/>
                            <circle cx="26.25" cy="55" r="10" stroke="#004F7F" stroke-width="3"/>
                            <circle cx="56.25" cy="55" r="10" stroke="#004F7F" stroke-width="3"/>
                            <path d="M36.25 55C37.0833 54.1667 38.125 52.5 41.25 52.5C44.375 52.5 45.4167 54.1667 46.25 55" stroke="#004F7F" stroke-width="3" stroke-linecap="round"/>
                            <path d="M40 32.5C50.8941 32.5 57.2082 34.9566 66.2041 39.3651C67.1517 39.8295 66.8192 41.25 65.7639 41.25H14.2361C13.1808 41.25 12.8483 39.8295 13.7959 39.3651C22.7918 34.9566 29.1059 32.5 40 32.5Z" fill="#004F7F"/>
                            <path d="M29.7774 16.3355C29.888 15.6719 30.6092 15.3046 31.211 15.6055L36.4359 18.2179C37.1194 18.5597 37.9076 18.6277 38.6396 18.4081L48.9129 15.3261C49.4897 15.1531 50.0876 15.5255 50.1866 16.1196L52.3059 28.8356C52.4075 29.4451 51.9375 30 51.3195 30H28.6805C28.0625 30 27.5925 29.4451 27.6941 28.8356L29.7774 16.3355Z" fill="#004F7F"/>
                        </svg>
                        <div class="not-verified-content">
                            <div class="not-verified-content-text">
                                <div class="not-verified-content-title">Strong Customer Authentication Required</div>
                                <div class="not-verified-content-info">To comply with EU regulations and protect your account, access to your wallet now requires Strong Customer Authentication (SCA).<br/>This security step is mandated by MangoPay, our regulated payment provider, to ensure your funds and transactions are safe.<br/>Please complete the SCA verification to continue.</div>
                            </div>
                            <div class="verify-btn" v-on:click="verifySca2">Start SCA Validation</div>
                        </div>
                    </div>
                </div>
                <div class="not-verified-wrapper" v-if="userDetails.mangopayScaStatusId === 0">
                    <div class="not-verified-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                            <circle cx="26.25" cy="55" r="10" fill="#B3CAD9"/>
                            <circle cx="56.25" cy="55" r="10" fill="#B3CAD9"/>
                            <path d="M22.1274 46.5651C23.2919 45.8218 24.6207 45.3131 26.047 45.1055L23.816 64.3001C22.4944 63.7762 21.3111 62.9786 20.3359 61.9774L22.1274 46.5651Z" fill="white"/>
                            <path d="M52.1274 46.5651C53.2919 45.8218 54.6207 45.3131 56.047 45.1055L53.816 64.3001C52.4944 63.7762 51.3111 62.9786 50.3359 61.9774L52.1274 46.5651Z" fill="white"/>
                            <circle cx="26.25" cy="55" r="10" stroke="#004F7F" stroke-width="3"/>
                            <circle cx="56.25" cy="55" r="10" stroke="#004F7F" stroke-width="3"/>
                            <path d="M36.25 55C37.0833 54.1667 38.125 52.5 41.25 52.5C44.375 52.5 45.4167 54.1667 46.25 55" stroke="#004F7F" stroke-width="3" stroke-linecap="round"/>
                            <path d="M40 32.5C50.8941 32.5 57.2082 34.9566 66.2041 39.3651C67.1517 39.8295 66.8192 41.25 65.7639 41.25H14.2361C13.1808 41.25 12.8483 39.8295 13.7959 39.3651C22.7918 34.9566 29.1059 32.5 40 32.5Z" fill="#004F7F"/>
                            <path d="M29.7774 16.3355C29.888 15.6719 30.6092 15.3046 31.211 15.6055L36.4359 18.2179C37.1194 18.5597 37.9076 18.6277 38.6396 18.4081L48.9129 15.3261C49.4897 15.1531 50.0876 15.5255 50.1866 16.1196L52.3059 28.8356C52.4075 29.4451 51.9375 30 51.3195 30H28.6805C28.0625 30 27.5925 29.4451 27.6941 28.8356L29.7774 16.3355Z" fill="#004F7F"/>
                        </svg>
                        <div class="not-verified-content">
                            <div class="not-verified-content-text">
                                <div class="not-verified-content-title">Strong Customer Authentication Required</div>
                                <div class="not-verified-content-info">To comply with EU regulations and protect your account, access to your wallet now requires Strong Customer Authentication (SCA).<br/>This security step is mandated by MangoPay, our regulated payment provider, to ensure your funds and transactions are safe.<br/>Please complete the SCA verification to continue.</div>
                            </div>
                            <div class="verify-btn" v-on:click="verifySca">Start SCA Validation</div>
                        </div>
                    </div>
                </div>
                <div class="not-verified-wrapper" v-if="userDetails.mangopayScaStatusId === 1">
                    <div class="not-verified-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                            <path d="M16.25 15C16.25 12.2386 18.4886 10 21.25 10H51.25L63.75 22.5V65C63.75 67.7614 61.5114 70 58.75 70H21.25C18.4886 70 16.25 67.7614 16.25 65V15Z" fill="#004F7F"/>
                            <path d="M63.75 22.5H54.25C52.5931 22.5 51.25 21.1569 51.25 19.5V10L63.75 22.5Z" fill="#B3CAD9"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M39.8006 31.6629L33.5957 53.8414C34.0338 54.4388 34.5228 55.0105 35.0628 55.5506C35.713 56.2007 36.4091 56.777 37.1407 57.2794L44.6136 30.5684C42.9721 30.6583 41.3427 31.0232 39.8006 31.6629ZM46.8536 30.6162L39.08 58.4019C39.7403 58.7189 40.4195 58.9834 41.1113 59.1957L49.0027 30.989C48.2949 30.8111 47.5764 30.6869 46.8536 30.6162Z" fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M57.5928 55.8251C63.0745 49.4407 62.791 39.8101 56.7424 33.7615C50.3964 27.4154 40.1075 27.4154 33.7615 33.7615C27.4154 40.1075 27.4154 50.3964 33.7615 56.7424C39.8101 62.7911 49.4407 63.0745 55.8251 57.5928L57.7773 59.545C57.1114 60.9389 57.3557 62.659 58.5103 63.8135L67.3491 72.6523C68.8136 74.1168 71.1879 74.1168 72.6524 72.6523C74.1169 71.1879 74.1169 68.8135 72.6524 67.349L63.8136 58.5102C62.659 57.3556 60.9389 57.1113 59.545 57.7772L57.5928 55.8251ZM54.0908 54.0908C58.9723 49.2092 58.9723 41.2947 54.0908 36.4131C49.2092 31.5316 41.2947 31.5316 36.4131 36.4131C31.5316 41.2947 31.5316 49.2092 36.4131 54.0908C41.2947 58.9723 49.2092 58.9723 54.0908 54.0908Z" fill="#B3CAD9"/>
                        </svg>
                        <div class="not-verified-content">
                            <div class="not-verified-content-text">
                                <div class="not-verified-content-title">Your SCA Validation is in Progress</div>
                                <div class="not-verified-content-info">You’ve started the Strong Customer Authentication process — great!<br/>We're now waiting for MangoPay to confirm your validation. This usually takes just a few minutes.<br/>As soon as you're verified, you’ll be able to access your wallet securely.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </v-layout>
        <v-layout column wrap fill-height="true" v-else>
            <div class="wallet-wrapper">
                <div class="not-verified-wrapper" v-if="statusKYC === 0">
                    <div class="not-verified-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                            <circle cx="26.25" cy="55" r="10" fill="#B3CAD9"/>
                            <circle cx="56.25" cy="55" r="10" fill="#B3CAD9"/>
                            <path d="M22.1274 46.5651C23.2919 45.8218 24.6207 45.3131 26.047 45.1055L23.816 64.3001C22.4944 63.7762 21.3111 62.9786 20.3359 61.9774L22.1274 46.5651Z" fill="white"/>
                            <path d="M52.1274 46.5651C53.2919 45.8218 54.6207 45.3131 56.047 45.1055L53.816 64.3001C52.4944 63.7762 51.3111 62.9786 50.3359 61.9774L52.1274 46.5651Z" fill="white"/>
                            <circle cx="26.25" cy="55" r="10" stroke="#004F7F" stroke-width="3"/>
                            <circle cx="56.25" cy="55" r="10" stroke="#004F7F" stroke-width="3"/>
                            <path d="M36.25 55C37.0833 54.1667 38.125 52.5 41.25 52.5C44.375 52.5 45.4167 54.1667 46.25 55" stroke="#004F7F" stroke-width="3" stroke-linecap="round"/>
                            <path d="M40 32.5C50.8941 32.5 57.2082 34.9566 66.2041 39.3651C67.1517 39.8295 66.8192 41.25 65.7639 41.25H14.2361C13.1808 41.25 12.8483 39.8295 13.7959 39.3651C22.7918 34.9566 29.1059 32.5 40 32.5Z" fill="#004F7F"/>
                            <path d="M29.7774 16.3355C29.888 15.6719 30.6092 15.3046 31.211 15.6055L36.4359 18.2179C37.1194 18.5597 37.9076 18.6277 38.6396 18.4081L48.9129 15.3261C49.4897 15.1531 50.0876 15.5255 50.1866 16.1196L52.3059 28.8356C52.4075 29.4451 51.9375 30 51.3195 30H28.6805C28.0625 30 27.5925 29.4451 27.6941 28.8356L29.7774 16.3355Z" fill="#004F7F"/>
                        </svg>
                        <div class="not-verified-content">
                            <div class="not-verified-content-text">
                                <div class="not-verified-content-title">{{ $t('wallet014') }}</div>
                                <div class="not-verified-content-info">{{ $t('wallet075') }}</div>
                                <div class="not-verified-box-wrapper">
                                    <div class="not-verified-box"></div>
                                    <div class="not-verified-box-text">{{ $t('wallet076') }}</div>
                                </div>
                            </div>
                            <div class="verify-btn" v-on:click="verifyNow">{{ $t('wallet077') }}</div>
                        </div>
                    </div>
                </div>
                <div class="not-verified-wrapper" v-if="statusKYC === 2">
                    <div class="not-verified-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                            <path d="M16.25 15C16.25 12.2386 18.4886 10 21.25 10H51.25L63.75 22.5V65C63.75 67.7614 61.5114 70 58.75 70H21.25C18.4886 70 16.25 67.7614 16.25 65V15Z" fill="#004F7F"/>
                            <path d="M63.75 22.5H54.25C52.5931 22.5 51.25 21.1569 51.25 19.5V10L63.75 22.5Z" fill="#B3CAD9"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M39.8006 31.6629L33.5957 53.8414C34.0338 54.4388 34.5228 55.0105 35.0628 55.5506C35.713 56.2007 36.4091 56.777 37.1407 57.2794L44.6136 30.5684C42.9721 30.6583 41.3427 31.0232 39.8006 31.6629ZM46.8536 30.6162L39.08 58.4019C39.7403 58.7189 40.4195 58.9834 41.1113 59.1957L49.0027 30.989C48.2949 30.8111 47.5764 30.6869 46.8536 30.6162Z" fill="white"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M57.5928 55.8251C63.0745 49.4407 62.791 39.8101 56.7424 33.7615C50.3964 27.4154 40.1075 27.4154 33.7615 33.7615C27.4154 40.1075 27.4154 50.3964 33.7615 56.7424C39.8101 62.7911 49.4407 63.0745 55.8251 57.5928L57.7773 59.545C57.1114 60.9389 57.3557 62.659 58.5103 63.8135L67.3491 72.6523C68.8136 74.1168 71.1879 74.1168 72.6524 72.6523C74.1169 71.1879 74.1169 68.8135 72.6524 67.349L63.8136 58.5102C62.659 57.3556 60.9389 57.1113 59.545 57.7772L57.5928 55.8251ZM54.0908 54.0908C58.9723 49.2092 58.9723 41.2947 54.0908 36.4131C49.2092 31.5316 41.2947 31.5316 36.4131 36.4131C31.5316 41.2947 31.5316 49.2092 36.4131 54.0908C41.2947 58.9723 49.2092 58.9723 54.0908 54.0908Z" fill="#B3CAD9"/>
                        </svg>
                        <div class="not-verified-content">
                            <div class="not-verified-content-text">
                                <div class="not-verified-content-title">{{ $t('wallet072') }}</div>
                                <div class="not-verified-content-info">{{ $t('wallet073') }}</div>
                                <div class="not-verified-box-wrapper2">
                                    <div class="not-verified-box2"></div>
                                    <div class="not-verified-box-text">{{ $t('wallet074') }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="not-verified-wrapper" v-if="statusKYC === 3 || statusKYC === 4">
                    <div class="not-verified-card">
                        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                            <path d="M32.4174 16.9355C35.7874 11.0215 44.2126 11.0215 47.5826 16.9355L68.8139 54.1936C72.184 60.1075 67.9714 67.5 61.2313 67.5H18.7687C12.0286 67.5 7.81605 60.1075 11.1861 54.1935L32.4174 16.9355Z" fill="#D5394F"/>
                            <path d="M15 59.4765V55.3716C15 53.859 17.1856 53.6467 17.4766 55.1311L17.9431 57.51C18.0603 58.1078 18.3918 58.6423 18.8753 59.013L21.3019 60.8734C22.4297 61.738 21.4698 63.5147 20.1284 63.0452L16.6741 61.8362C15.6714 61.4852 15 60.5389 15 59.4765Z" fill="#8B0101"/>
                            <path d="M35.2497 31.2438C35.1139 28.5271 37.2799 26.25 40 26.25C42.7201 26.25 44.8861 28.5271 44.7503 31.2438L44.1998 42.255C44.0879 44.4929 42.2407 46.25 40 46.25C37.7593 46.25 35.9121 44.4929 35.8002 42.255L35.2497 31.2438Z" fill="white"/>
                            <circle cx="40" cy="53.75" r="3.75" fill="white"/>
                        </svg>
                        <div class="not-verified-content">
                            <div class="not-verified-content-text">
                                <div class="not-verified-content-title">{{ $t('wallet078') }}</div>
                                <div class="not-verified-content-info">{{ $t('wallet081') }}</div>
                                <div class="not-verified-box-wrapper3">
                                    <div class="not-verified-box3"></div>
                                    <div class="not-verified-box-text">{{ $t('wallet079') }}</div>
                                </div>
                            </div>
                            <div class="verify-btn" v-on:click="verifyNow">{{ $t('wallet080') }}</div>
                        </div>
                    </div>
                </div>
                <div class="balance-wrapper" v-if="balance">
                    <div class="balance-container">
                        <div class="balance-container-block">
                            <div class="balance-text-wrapper">
                                <div class="balance-amount">{{balance.split('.')[0]}}<span class="balance-amount2">.{{balance.split('.')[1]}} EUR</span></div>
                                <div class="available-balance">
                                    <div class="available-balance-icon"></div>
                                    <div class="available-balance-info">{{ $t('wallet008') }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="balance-container-block"></div>
                    </div>
                    <v-btn text class="withdraw-btn" :disabled="statusKYC !== 1" v-on:click="withdrawFunds">{{ $t('wallet010') }}</v-btn>
                </div>
                <div class="not-verified-wrapper2" v-if="statusKYC === 1"></div>
            </div>

            <div class="wallet-transactions-title">Wallet transactions history</div>
            <div class="transactions-wrapper">
                <div class="transactions-wrapper-content" v-if="!transactions.list.length">
                    <div class="no-transactions"></div>
                    <div class="no-transactions-text">You haven’t made any transactions yet</div>
                </div>
                <div v-else>
                    <div class="transaction-item" v-for="(item, index) in transactions.list" :key="index">
                        <div style="position: relative; display: flex; gap: 8px;">
                            <v-img v-if="item.type === 4" class="header-image2" :src="require('../assets/collections.png')" />
                            <v-img v-else-if="item.type === 3 || item.type === 6" class="header-image2" :src="require('../assets/wine_icon.png')" />
                            <v-img v-else-if="item.type === 5" class="header-image2" :src="require('../assets/receipt.png')" />
                            <v-img v-else class="header-image2" :src="require('../assets/payout.png')" />
                            <div class="created-dot" v-if="item.status === 1"></div>
                            <div class="failed-dot" v-else-if="item.status === 4"></div>
                            <div class="success-dot" v-else></div>
                            <div>
                                <div class="transactions-title">{{item.type === 2 ? `${item.beneficiaryName} *${item.iban}` : item.name}}</div>
                                <div class="transactions-text">{{transactionDesc(item.type)}}</div>
                            </div>
                        </div>
                        <div style="align-items: flex-end;">
                            <div class="transactions-amount-sale" v-if="item.type === 6">{{formatPrice(item.amount.toFixed(2))}}</div>
                            <div class="transactions-amount" v-else>{{formatPrice(item.amount.toFixed(2))}}</div>
                            <div class="transactions-text">{{item.creationDate}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </v-layout>

        <v-dialog v-model="missingAddress" max-width="500px" persistent>
            <v-card class="bids-offers-modal confirm-address-modal">
                <v-card-title>Missing billing address</v-card-title>
                <v-card-text class="cancel-bid-body">
                    You should first add a billing address
                </v-card-text>
                <v-card-actions>
                    <v-btn class="btn-primary btn-bid-proceed" text v-on:click="() => { missingAddress = false }">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {APortfolio, AUser} from "@/store/actions";
import {GCommon, GUser} from "@/store/getters";
import {MUser} from '@/store/mutations'

export default {
    name: "Wallet",
    head: {
        title: 'Wallet | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
    },
    data() {
        return {
            isLoading: true,
            isLogged: false,
            missingAddress: false,
            selectedTab: "transactions",
        }
    },
    computed: {
        ...mapGetters({
            mobileCheck: GCommon.GET_MOBILE_VERSION,
            statusKYC: GUser.GET_KYC_STATUS,
            addressList: GUser.GET_ADDRESSES,
            transactions: GUser.GET_WALLET_TRANSACTIONS,
            balance: GUser.GET_WALLET_BALANCE,
            balanceSca: GUser.GET_WALLET_BALANCE_SCA,
            userDetails: GUser.GET_USER_DATA
        })
    },
    methods: {
        verifyNow() {
            if (!this.addressList.length) {
                this.missingAddress = true
            } else {
                this.$router.push(this.localePath({path: '/verify-your-identity'}));
            }
        },
        verifySca() {
            this.$store.dispatch(AUser.GET_SCA_ENROLL).then(response => {
                window.location.href = response.pendingUserAction.redirectUrl.replace('www.vindome.net', 'vindome.net' + encodeURIComponent(window.location.pathname + window.location.search))
            });
        },
        verifySca2() {
            window.location.href = this.balance.replace('www.vindome.net', 'vindome.net' + encodeURIComponent(window.location.pathname + window.location.search))
        },
        withdrawFunds() {
            this.$router.push(this.localePath({path: '/enter-amount'}));
        },
        transactionDesc(type) {
            if (type === 4) {
                return 'Collection Purchase'
            } else if (type === 3) {
                return 'Live Market Purchase'
            } else if (type === 5) {
                return 'Service Fees'
            } else if (type === 6) {
                return 'Live Market Sale'
            } else {
                return 'Withdrawal'
            }
        },
        formatPrice(price) {
            return `€ ${price}`
        }
    },
    created() {
        this.$store.dispatch(AUser.GET_USER_DATA).then(() => {
            this.isLogged = true;
            this.$store.dispatch(APortfolio.GET_PORTFOLIO_SUMMARY);
            this.$store.dispatch(AUser.GET_USER_COMMISSION);
            this.$store.dispatch(AUser.GET_KYC_STATUS);
            this.$store.commit(MUser.RESET_WALLET_TRANSACTIONS);
            this.$store.dispatch(AUser.GET_WALLET_TRANSACTIONS, 1)

            if (parseInt(this.userDetails.mangopayScaStatusId) === 2) {
                this.$store.dispatch(AUser.GET_WALLET_BALANCE)
            }
        }).catch(() => {
            this.isLogged = false;
        });
    }
}
</script>

<style scoped>
#sca-iframe {
    min-height: 650px;
    width: 100%;
    margin-top: 32px;
}
.transactions-title {
    color: rgba(0, 0, 0, 0.88);
    font-family: Montserrat, sans-serif;
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
}
.transactions-text {
    color: rgba(0, 0, 0, 0.64);
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
}
.transactions-amount-sale {
    color: #018671;
    text-align: right;
    font-family: Montserrat, sans-serif;
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
}
.transactions-amount {
    color: #D5394F;
    text-align: right;
    font-family: Montserrat, sans-serif;
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
}
.header-image2 {
    height: 40px;
    width: 40px;
}
.success-dot {
    width: 14px;
    height: 14px;
    border-radius: 7px;
    background-color: #018671;
    position: absolute;
    left: 28px;
    top: 28px;
    border: 2px solid white;
}
.failed-dot {
    width: 14px;
    height: 14px;
    border-radius: 7px;
    background-color: #D5394F;
    position: absolute;
    left: 28px;
    top: 28px;
    border: 2px solid white;
}
.created-dot {
    width: 14px;
    height: 14px;
    border-radius: 7px;
    background-color: #FF7E4F;
    position: absolute;
    left: 28px;
    top: 28px;
    border: 2px solid white;
}
.transaction-item {
    padding-top: 16px;
    padding-bottom: 16px;
    height: 72px;
    justify-content: space-between;
    display: flex;
}
.wallet-transactions-title {
    color: rgba(0, 0, 0, 0.88);
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding: 12px 0;
}
.bids-offers-modal {
    padding: 32px 48px;
    text-align: center;
    background: #f6f6f6;
}
.transactions-wrapper-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    flex: 1 0 0;
    align-self: stretch;
    margin-top: 65px;
    margin-bottom: 65px;
}
.no-transactions {
    width: 180px;
    height: 151px;
    background: url('../assets/no_transactions.png') no-repeat center;
    background-size: contain;
}
.no-transactions-text {
    color: rgba(0, 0, 0, 0.38);
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}
.my-profile-vertical-tabs .v-window.v-item-group.theme--light.transactions-tabs {
    padding: 0;
    background: white;
    border-radius: 8px;
    margin-top: 16px;
    margin-bottom: 32px;
}
.v-tabs--icons-and-text .myprofile-wrapper .my-profile-vertical-tabs .portfolio-tabs.portfolio-tabs2 .v-tab.v-tab--active {
    z-index: 9;
}
.transactions-wrapper {
    display: flex;
    padding: 0 16px;
    gap: 8px;
    align-self: stretch;
    flex-direction: column;
    background-color: white;
    border-radius: 8px;
    margin-bottom: 32px;
}
.wallet-wrapper {
    display: flex;
    padding-top: 24px;
    align-items: flex-start;
    gap: 40px;
    align-self: stretch;
    margin-bottom: 32px;
}
.not-verified-wrapper {
    display: flex;
    padding: 0 16px;
    align-items: flex-start;
    flex: 1 0 0;
    border-radius: 8px;
    background: #FFF;
    align-self: stretch;
}
.not-verified-wrapper2 {
    display: flex;
    padding: 0 16px;
    align-items: flex-start;
    flex: 1 0 0;
    align-self: stretch;
}
.balance-wrapper {
    display: flex;
    padding: 12px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    flex: 1 0 0;
    border-radius: 8px;
    background: #FFF;
}
.balance-container {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    flex: 1 0 0;
    align-self: stretch;
}
.not-verified-card {
    display: flex;
    padding: 16px 0;
    align-items: flex-start;
    gap: 8px;
    flex: 1 0 0;
}
.not-verified-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 16px;
    flex: 1 0 0;
    align-self: stretch;
}
.not-verified-content-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    align-self: stretch;
}
.not-verified-content-title {
    color: rgba(0, 0, 0, 0.88);
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
}
.not-verified-content-info {
    color: rgba(0, 0, 0, 0.64);
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
}
.not-verified-box-wrapper {
    display: flex;
    align-items: center;
    padding: 1px 4px 1px 5px;
    gap: 3px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.38);
}
.not-verified-box-wrapper2 {
    display: flex;
    align-items: center;
    padding: 1px 4px 1px 5px;
    gap: 3px;
    border-radius: 4px;
    border: 1px solid #FF7E4F;
}
.not-verified-box-wrapper3 {
    display: flex;
    align-items: center;
    padding: 1px 4px 1px 5px;
    gap: 3px;
    border-radius: 4px;
    border: 1px solid #D5394F;
}
.not-verified-box {
    width: 6px;
    height: 6px;
    border-radius: 1px;
    background: rgba(0, 0, 0, 0.38);
}
.not-verified-box2 {
    width: 6px;
    height: 6px;
    border-radius: 1px;
    background: #FF7E4F;
}
.not-verified-box3 {
    width: 6px;
    height: 6px;
    border-radius: 1px;
    background: #D5394F;
}
.not-verified-box-text {
    color: rgba(0, 0, 0, 0.88);
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
.verify-btn {
    color: #004F7F;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}
.verify-btn:hover {
    cursor: pointer;
}
.balance-container-block {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    flex: 1 0 0;
    margin-bottom: 16px;
}
.balance-text-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.balance-amount {
    color: rgba(0, 0, 0, 0.88);
    font-family: Montserrat, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}
.balance-amount2 {
    color: rgba(0, 0, 0, 0.88);
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}
.available-balance {
    display: flex;
    align-items: center;
    gap: 4px;
}
.available-balance-icon {
    width: 16px;
    height: 16px;
    background: url('../assets/icons/ui_euro.png') no-repeat center;
    background-size: contain;
}
.available-balance-info {
    color: rgba(0, 0, 0, 0.88);
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
.v-btn:not(.v-btn--round).v-size--default.withdraw-btn {
    display: flex;
    height: 51px;
    padding: 16px 32px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    background: #004F7F;
    width: 100%;
    color: #FFF;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    text-decoration: none;
}
.theme--light.v-btn.v-btn--disabled.withdraw-btn {
    display: flex;
    height: 51px;
    padding: 16px 32px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    background: #D9D7DB;
    width: 100%;
    color: rgba(4, 1, 13, 0.4);
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    cursor: not-allowed;
}
</style>

<style>
.v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__title{
    color: rgba(0, 0, 0, 0.88);
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding: 16px;
}
.v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions {
    padding: 20px 16px 0;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
}
.v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions > .v-btn.btn-bid-close {
    flex: 1 0 0;
    border-radius: 8px;
    border: 2px solid #004F7F;
    background: transparent;
    display: flex;
    padding: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    margin-right: 0;
    height: 51px;
}
.v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions > .v-btn.btn-bid-close .v-btn__content {
    color: #004F7F;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
}
.v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions > .v-btn.btn-bid-proceed {
    border-radius: 8px;
    background: #004F7F;
    border: 2px solid #004F7F;
    display: flex;
    padding: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    flex: 1 0 0;
    margin-left: 0;
    height: 51px;
}
.v-dialog > .v-card.confirm-address-modal.bids-offers-modal > .v-card__actions > .v-btn.btn-bid-proceed .v-btn__content {
    color: #FFF;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
}
</style>
